<ng-template #rowActions let-affiliate>
    <action-menu [items]="actionMenuItems" (clickAction)="actions[$event.valueOf()].emit(affiliate)" [actionData]="affiliate"></action-menu>
  <!-- <a
    mat-icon-button
    [routerLink]="['/affiliates', affiliate.id]"
    aria-label="Detail"
    matTooltip="Detail"
  >
    <mat-icon>visibility</mat-icon>
  </a>
  @if ((affiliate.isActive && canDeactivate()) || (!affiliate.isActive && canActivate())) {
    <button
      mat-icon-button
      type="button"
      [disabled]="actionAffiliateId() === affiliate.id"
      (click)="toggled.emit(affiliate)"
      [attr.aria-label]="affiliate.isActive ? 'Deactivate' : 'Activate'"
      [matTooltip]="affiliate.isActive ? 'Deactivate' : 'Activate'"
    >
      @if (actionAffiliateId() === affiliate.id) {
        <mat-spinner diameter="18" />
      } @else {
        <mat-icon>{{ affiliate.isActive ? 'block' : 'check_circle' }}</mat-icon>
      }
    </button>
  } -->
</ng-template>

<data-table
  title="Affiliates"
  searchLabel="Search affiliates"
  searchPlaceholder="Name or email"
  loadingMessage="Loading affiliates..."
  emptyMessage="No affiliates found."
  [rows]="affiliates()"
  [columns]="columns"
  [actionsTemplate]="rowActions"
  [loading]="loading()"
  [showRefresh]="true"
  [searchEnabled]="true"
  [searchTerm]="searchTerm()"
  [paginationEnabled]="true"
  [pageNumber]="pageNumber()"
  [pageSize]="pageSize()"
  [totalCount]="totalCount()"
  [totalPages]="totalPages()"
  (refreshed)="refreshed.emit()"
  (searchChanged)="searchChanged.emit($event)"
  (pageChanged)="pageChanged.emit($event)" />
